import useDemoStore from 'common/src/stores/useDemoStore';
import { Alert } from './ui';
import { Icon } from '@iconify/react';

const DemoBanner = () => {
  const { demoAccessUntil } = useDemoStore();

  if (!demoAccessUntil) return null;

  const formattedDate = new Date(
    demoAccessUntil + 'T00:00:00'
  ).toLocaleDateString('es-CL');

  return (
    <div className='w-full sticky top-0 z-50'>
      <Alert variant='default' className='rounded-none border-x-0 border-t-0'>
        <div className='flex items-center gap-2'>
          <Icon icon='tabler:info-circle' className='flex-shrink-0' width={18} />
          <span>
            Estás en una cuenta demo con acceso hasta el {formattedDate}.
          </span>
        </div>
      </Alert>
    </div>
  );
};

export default DemoBanner;
